import React, { useEffect, useState } from "react";
import { API_BASE_URL } from "src/config/apiBase";
import { decryptToken } from "../utils/getToken";
import moment from "moment-timezone";

const EVENT_ICONS = {
  enquiry_created: "📥",
  note: "📝",
  connected: "📞",
  reminder: "⏰",
  converted: "✅",
  rating: "⭐",
  audit: "📋",
};

const CrmActivityTimeline = ({ leadId }) => {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const url = API_BASE_URL;
  const token = decryptToken("accessToken") || "";

  useEffect(() => {
    if (!leadId) return;
    let cancelled = false;
    setLoading(true);
    fetch(`${url}/leads/timeline/${leadId}`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((r) => (r.ok ? r.json() : { events: [] }))
      .then((data) => {
        if (!cancelled) setEvents(Array.isArray(data.events) ? data.events : []);
      })
      .catch(() => {
        if (!cancelled) setEvents([]);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [leadId, url, token]);

  if (!leadId) return null;

  if (loading) {
    return <p className="crm-timeline__muted">Loading activity…</p>;
  }

  if (!events.length) {
    return <p className="crm-timeline__muted">No activity yet for this lead.</p>;
  }

  return (
    <div className="crm-timeline">
      {events.map((event, idx) => {
        const at = event.at
          ? moment(event.at).tz("Asia/Kolkata").format("DD MMM YYYY, h:mm A")
          : "";
        return (
          <div key={`${event.type}-${event.at}-${idx}`} className="crm-timeline__item">
            <span className="crm-timeline__icon" aria-hidden>
              {EVENT_ICONS[event.type] || "•"}
            </span>
            <div className="crm-timeline__body">
              <div className="crm-timeline__title">{event.title}</div>
              {event.detail && (
                <p className="crm-timeline__detail">{event.detail}</p>
              )}
              {at && <time className="crm-timeline__time">{at}</time>}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default CrmActivityTimeline;
